import { render } from "./BadgePage.vue?vue&type=template&id=1ef14012&scoped=true"
import script from "./BadgePage.vue?vue&type=script&lang=js"
export * from "./BadgePage.vue?vue&type=script&lang=js"

import "./BadgePage.vue?vue&type=style&index=0&id=1ef14012&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef14012"]])

export default __exports__